import React from 'react'
import { Link } from 'react-router-dom'
import './page-auth.css'
export const AuthWrapper = ({ children }) => {
    return (
        <div className="container-xxl" style={{backgroundImage: 'url(/assets/img/backgroung-img.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}}>
            <div className="authentication-wrapper authentication-basic container-p-y">
                <div className="authentication-inner">
                    <div className="card">
                        <div className="card-body">
                            <div className="app-brand justify-content-center">
                                <Link aria-label='Go to Home Page' to="/" className="app-brand-link gap-2">
                                    <span className="app-brand-logo demo">
                                        <img 
                        src="/assets/img/logo/proton-logo.png" 
                        alt="Proton Car Wash" 
                        style={{ height: '40px' }} 
                        aria-label='Proton Car Wash logo'
                    />
                                    </span>
                                    
                                </Link>
                            </div>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
